import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.jpg";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);
  const [showTopBar, setShowTopBar] = useState(true);

  // Detect scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setShowTopBar(true);
      } else {
        setShowTopBar(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="sticky top-0 z-50">
      {/* Topmost Admin Login Bar - hidden when scrolled */}
      {showTopBar && (
        <div className="bg-white shadow flex justify-end px-6 py-2 transition-all duration-300">
          <Link
            to="/login"
            className="text-blue-800 hover:underline font-semibold"
          >
            Login
          </Link>
        </div>
      )}

      {/* Main Navbar */}
      <nav className="bg-blue-800 shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img src={logo} alt="Logo" className="h-10 w-10" />
            <span className="text-lg font-bold text-white ml-2">
              Indangalasia Lightstar Academy
            </span>
          </Link>

          {/* Hamburger Button for Mobile */}
          <button
            className="lg:hidden text-white focus:outline-none"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>

          {/* Navigation Links */}
          <div
            className={`lg:flex space-x-6 absolute lg:static bg-blue-800 w-full lg:w-auto left-0 top-16 lg:top-0 px-6 py-4 lg:p-0 shadow-md lg:shadow-none transition-all duration-300 ease-in-out ${
              menuOpen ? "block" : "hidden"
            }`}
          >
            <Link
              to="/about"
              className="block lg:inline-block text-white hover:text-blue-200 py-2"
            >
              About
            </Link>
            <Link
              to="/academics"
              className="block lg:inline-block text-white hover:text-blue-200 py-2"
            >
              Academics
            </Link>
            <Link
              to="/sponsorship"
              className="block lg:inline-block text-white hover:text-blue-200 py-2"
            >
              Sponsorship
            </Link>

            {/* Other Ways to Support Dropdown */}
            <div
              className="relative block lg:inline-block"
              onMouseEnter={() => {
                clearTimeout(window.dropdownTimeout);
                setSupportOpen(true);
              }}
              onMouseLeave={() => {
                window.dropdownTimeout = setTimeout(() => {
                  setSupportOpen(false);
                }, 300);
              }}
            >
              <button
                className="text-white hover:text-blue-200 py-2 w-full text-left lg:text-center flex items-center"
                onClick={() => setSupportOpen(!supportOpen)}
              >
                Other Ways to Support
                <svg
                  className="ml-2 h-4 w-4 transform transition-transform duration-200"
                  style={{ transform: supportOpen ? "rotate(180deg)" : "rotate(0deg)" }}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {supportOpen && (
                <div
                  className="absolute bg-white shadow-lg rounded-md mt-2 w-44 left-0 lg:left-auto z-50"
                >
                  <Link
                    to="/volunteer"
                    className="block px-4 py-2 hover:bg-gray-100 text-gray-800"
                  >
                    Volunteer
                  </Link>
                  <Link
                    to="/support-once"
                    className="block px-4 py-2 hover:bg-gray-100 text-gray-800"
                  >
                    One-time Donation
                  </Link>
                </div>
              )}
            </div>

            <Link
              to="/donate"
              className="block lg:inline-block bg-white text-blue-800 px-4 py-2 rounded-lg hover:bg-blue-100 font-semibold transition"
            >
              Donate
            </Link>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
